import React from 'react';
import PropTypes from 'prop-types';
import { formatTransferDate } from '../../utils/recipientHelpers';

function TimelineItem({ title, dateLabel, done, failed, isLast }) {
  let dotColor = 'var(--color-border)';
  if (failed) {
    dotColor = 'var(--color-error)';
  } else if (done) {
    dotColor = '#22c55e';
  }
  const showFilledDot = done || failed;

  return (
    <div className={`flex items-start gap-3.5 ${isLast ? '' : 'pb-4'}`}>
      <div
        className='mt-[5px] h-2.5 w-2.5 shrink-0 rounded-full'
        style={{
          background: showFilledDot ? dotColor : 'transparent',
          border: showFilledDot ? 'none' : '2px solid var(--n400)',
        }}
      />
      <div className='min-w-0 flex-1'>
        <div className='text-[13.5px] font-medium text-[var(--n900)]'>{title}</div>
        {dateLabel && <div className='mt-[3px] text-[11.5px] text-[var(--text-tertiary)]'>{dateLabel}</div>}
      </div>
    </div>
  );
}

TimelineItem.propTypes = {
  title: PropTypes.string.isRequired,
  dateLabel: PropTypes.string,
  done: PropTypes.bool,
  failed: PropTypes.bool,
  isLast: PropTypes.bool,
};

TimelineItem.defaultProps = {
  dateLabel: null,
  done: false,
  failed: false,
  isLast: false,
};

function TransactionTimeline({ timeline }) {
  if (!timeline?.length) return null;

  return (
    <div>
      <div className='mb-4 text-[10px] font-semibold uppercase tracking-[0.13em] text-[var(--text-tertiary)]'>Timeline</div>
      <div>
        {timeline.map((event) => (
          <TimelineItem
            key={`${event.title}-${event.date || 'pending'}`}
            title={event.title}
            dateLabel={event.date ? formatTransferDate(event.date) : null}
            done={event.done}
            failed={event.failed}
            isLast={event === timeline[timeline.length - 1]}
          />
        ))}
      </div>
    </div>
  );
}

TransactionTimeline.propTypes = {
  timeline: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      date: PropTypes.string,
      done: PropTypes.bool,
      failed: PropTypes.bool,
    }),
  ),
};

TransactionTimeline.defaultProps = {
  timeline: [],
};

export default TransactionTimeline;
